import DocumentSchema from '@/components/DocumentSchema/DocumentSchema';
import { useSEO } from '@/hooks/useCompany';
import { getPartOf } from '@/hooks/useCompany/useSEO/utils';
import type { WebPage } from 'schema-dts';
import { CompanyReportSection } from '../useSection';
import { REPORT_SECTION_TITLE } from '../constants';
import useCompanyVariant from '@/pages/CompanyReport/hooks/useCompanyVariant';

export const SectionSchema = ({
  section,
}: {
  section: CompanyReportSection;
}) => {
  const {
    companyName,
    title,
    description,
    canonicalUrl,
    canonicalUrlWithHost,
    status,
  } = useSEO('summary');

  //this experiment test new section schema for 50% of companies
  const urlHashSchema = useCompanyVariant(canonicalUrl + 'section-schema');
  //TODO @RIC: Remove section-schema experiment after disabling by forcing showExperimentSchema === false
  const showExperimentSchema = parseInt(urlHashSchema, 16) >= 16;

  if (
    status !== 'success' ||
    !showExperimentSchema ||
    canonicalUrl === undefined
  )
    return null;

  return (
    <DocumentSchema<WebPage>
      item={{
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        specialty: [
          {
            '@type': 'Specialty',
            name: 'Teaching retail investors how to research stocks',
          },
        ],
        mainEntity: {
          '@type': 'CreativeWork',
          about: {
            '@type': 'Thing',
            name: `The page contains information regarding the ${REPORT_SECTION_TITLE[section]} of ${companyName}`,
          },
          url: canonicalUrlWithHost,
          description,
          audience: 'Retail Investors',
          author: {
            '@type': 'Organization',
            name: 'Simply Wall St Pty Ltd.',
          },
          dateModified: '2023-08-25T00:00:00.000Z',
          headline: title,
          isAccessibleForFree: true,
          isPartOf: getPartOf(section, canonicalUrlWithHost),
        },
      }}
    />
  );
};
